import React from "react";
import { StyledEditorialStories } from "./styles.js";
const EditorialStories = ({ title, text, cta, list }) => {
  return <StyledEditorialStories>EditorialStories</StyledEditorialStories>;
};

export default EditorialStories;
